// ============================================================
// OMYA Digital Plant – i18n facade
// Language is read from localStorage.lang (default 'cs').
// Switching language calls `setLanguage()` and reloads the app
// (sync t() function — simpler than React context for a demo).
// ============================================================

import cs from './cs';
import en from './en';
import pl from './pl';
import de from './de';
import { LANGUAGES, DEFAULT_LANGUAGE } from './languages';

const dicts = { cs, en, pl, de };
const isSupported = (code) => LANGUAGES.some(l => l.code === code);

export function getLanguage() {
  try {
    const stored = localStorage.getItem('omya_lang');
    return isSupported(stored) ? stored : DEFAULT_LANGUAGE;
  } catch {
    return DEFAULT_LANGUAGE;
  }
}

// BCP 47 locale for dates and numbers, e.g. 'pl-PL'.
export function getLocale() {
  return LANGUAGES.find(l => l.code === getLanguage()).locale;
}

export function setLanguage(lang) {
  try {
    localStorage.setItem('omya_lang', lang);
  } catch {
    /* ignore */
  }
  // Simple reload — re-renders the whole tree in the chosen language.
  window.location.reload();
}

export function t(key) {
  const lang = getLanguage();
  const dict = dicts[lang] || cs;
  return dict[key] || cs[key] || key;
}

if (typeof document !== 'undefined') {
  document.documentElement.lang = getLanguage();
}

export { LANGUAGES };

export default { t, getLanguage, getLocale, setLanguage };
